import { RegionViewModel } from "../../../viewmodels/RegionViewModel.js";
import { useOnClickOutside } from "../../../../../hooks/useOnClickOutside.js";
import { AppShellViewModel } from "../../../viewmodels/AppShellViewModel.js";
import { RegionPicker } from "./RegionPicker.js";
import { useRef, useState } from "react";
import { Button, Icon } from "@therms/atalaya";
import { FaStar } from "react-icons/fa";
import { jsx, jsxs } from "react/jsx-runtime";
import classnames from "classnames";
import { useSingleton } from "mvc-kit/react";
import { MdExpandMore } from "react-icons/md";
//#region src/modules/AppWrapper2/components/AppNav/components/OrgInfo.tsx
function OrgInfo({ compact }) {
	const shellVM = useSingleton(AppShellViewModel);
	const regionVM = useSingleton(RegionViewModel);
	const organization = shellVM.organization;
	const availableRegions = regionVM.availableRegions;
	const currentRegion = regionVM.currentRegion;
	const selectedRegions = regionVM.selectedRegions;
	const userPrimaryRegionId = regionVM.userPrimaryRegionId;
	const isMultiRegion = !!organization?.modules?.regions;
	const [isOpen, setIsOpen] = useState(false);
	const ref = useRef(null);
	useOnClickOutside(ref, () => setIsOpen(false));
	const showRegions = !regionVM.state.scopeAllRegions && availableRegions.length > 1;
	if (!organization) return null;
	if (!showRegions) {
		if (compact) return null;
		return /* @__PURE__ */ jsx("div", {
			className: "text-color text-sm font-semibold",
			children: organization.name
		});
	}
	const isPrimaryRegion = isMultiRegion && !!currentRegion && selectedRegions.length <= 1 && userPrimaryRegionId === currentRegion.id;
	return /* @__PURE__ */ jsxs("div", {
		className: "relative",
		ref,
		children: [/* @__PURE__ */ jsx(Button, {
			className: "group",
			onClick: () => setIsOpen(!isOpen),
			size: "sm",
			subtle: true,
			variant: "neutral",
			children: /* @__PURE__ */ jsxs("div", {
				className: "gap-x-sm inline-flex items-center text-sm",
				children: [
					!compact && /* @__PURE__ */ jsx("span", {
						className: "text-color-strong font-semibold",
						children: organization.name
					}),
					isMultiRegion && currentRegion && /* @__PURE__ */ jsx("span", {
						className: "text-color font-normal",
						children: selectedRegions.length > 1 ? /* @__PURE__ */ jsxs("span", {
							className: "text-neutral italic",
							children: [selectedRegions.length, " Regions"]
						}) : /* @__PURE__ */ jsxs("span", {
							className: "gap-x-xxs flex items-center",
							children: [isPrimaryRegion && /* @__PURE__ */ jsx(Icon, {
								className: "shrink-0",
								color: "info",
								Icon: FaStar,
								size: "xs"
							}), /* @__PURE__ */ jsx("span", {
								className: classnames("truncate", compact ? "max-w-32" : "max-w-48"),
								children: currentRegion.name
							})]
						})
					}),
					/* @__PURE__ */ jsx(Icon, {
						className: classnames("transition-transform", { "rotate-180": isOpen }),
						Icon: MdExpandMore,
						size: "sm"
					})
				]
			})
		}), isOpen && /* @__PURE__ */ jsx("div", {
			className: "z-dropdown mt-sm absolute top-full left-0 w-screen max-w-[350px] sm:px-0",
			children: /* @__PURE__ */ jsx(RegionPicker, { onCloseRegionPicker: () => {
				if (!regionVM.state.allowMultiRegionSelection) setIsOpen(false);
			} })
		})]
	});
}
//#endregion
export { OrgInfo };

//# sourceMappingURL=OrgInfo.js.map